export default __webpack_public_path__ + "static/media/pato.d6869cbd.png";